/* Click-to-play, infinite luxury auto-drift, and industry-standard Story / Reel Modal for PDP */
(function () {
  var isStoryModalOpen = false;
  var isHovered = false;
  var isPointerDown = false;
  var resumeTimeout = null;

  var currentStoryIndex = 0;
  var stories = [];
  var modalEl = null;
  var modalVideo = null;
  var modalStage = null;
  var modalBarsContainer = null;
  var modalTitle = null;
  var modalCaption = null;
  var modalScrubberBar = null;
  var modalTimer = null;
  var modalSoundBtn = null;
  var modalPlayStatePill = null;
  var modalPlayPauseBtn = null;

  function collectStories() {
    stories = [];
    var originalCards = Array.from(document.querySelectorAll('.mdvp-reel-ribbon .mdvp-reel-card:not([data-mdvp-clone])'));
    originalCards.forEach(function (card, idx) {
      var v = card.querySelector('video');
      var vidUrl = card.getAttribute('data-video') || (v ? (v.getAttribute('src') || v.currentSrc) : '');
      var posterUrl = card.getAttribute('data-poster') || (v ? v.getAttribute('poster') : '');
      var title = card.getAttribute('data-title') || (card.querySelector('b') ? card.querySelector('b').textContent.trim() : '');
      var caption = card.getAttribute('data-caption') || (card.querySelector('small') ? card.querySelector('small').textContent.trim() : '');
      stories.push({
        index: idx,
        videoUrl: vidUrl,
        posterUrl: posterUrl,
        title: title,
        caption: caption
      });
    });
  }

  function initStoryModal() {
    modalEl = document.getElementById('mdvpStoryModal');
    if (!modalEl || modalEl.dataset.mdvpModalInit) return;
    modalEl.dataset.mdvpModalInit = '1';

    modalVideo = modalEl.querySelector('.mdvp-story-video');
    modalStage = modalEl.querySelector('.mdvp-story-stage');
    modalBarsContainer = modalEl.querySelector('.mdvp-story-bars');
    modalTitle = modalEl.querySelector('.mdvp-story-title');
    modalCaption = modalEl.querySelector('.mdvp-story-caption');
    modalScrubberBar = modalEl.querySelector('.mdvp-story-scrubber-bar');
    modalTimer = modalEl.querySelector('.mdvp-story-timer');
    modalSoundBtn = modalEl.querySelector('.mdvp-story-sound-toggle');
    modalPlayStatePill = modalEl.querySelector('.mdvp-story-playstate-pill');
    modalPlayPauseBtn = modalEl.querySelector('.mdvp-story-play-pause-btn');

    // Build story progress segments
    if (modalBarsContainer && stories.length > 0) {
      modalBarsContainer.innerHTML = '';
      for (var i = 0; i < stories.length; i++) {
        var seg = document.createElement('div');
        seg.className = 'mdvp-story-bar-item';
        seg.innerHTML = '<div class="mdvp-story-bar-fill"></div>';
        modalBarsContainer.appendChild(seg);
      }
    }

    // Toggle Play / Pause function
    function toggleStoryPlay() {
      if (!modalVideo) return;
      if (modalVideo.paused) {
        modalVideo.play().then(function () {
          if (modalStage) modalStage.classList.remove('is-paused');
        }).catch(function () {
          if (modalStage) modalStage.classList.add('is-paused');
        });
      } else {
        modalVideo.pause();
        if (modalStage) modalStage.classList.add('is-paused');
      }
    }

    // Tapping the video box, playstate pill, or bottom button toggles pause/play
    var videoBox = modalEl.querySelector('.mdvp-story-video-box');
    if (videoBox) {
      videoBox.addEventListener('click', function (e) {
        // Prevent toggle if clicking on top or bottom bars
        if (e.target.closest('.mdvp-story-top') || e.target.closest('.mdvp-story-bottom')) return;
        toggleStoryPlay();
      });
    }

    if (modalPlayStatePill) {
      modalPlayStatePill.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleStoryPlay();
      });
    }

    if (modalPlayPauseBtn) {
      modalPlayPauseBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleStoryPlay();
      });
    }

    // Sound Toggle
    if (modalSoundBtn) {
      modalSoundBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!modalVideo) return;
        modalVideo.muted = !modalVideo.muted;
        if (modalVideo.muted) {
          modalSoundBtn.classList.add('is-muted');
        } else {
          modalSoundBtn.classList.remove('is-muted');
        }
      });
    }

    // Time update & Progress tracking
    if (modalVideo) {
      modalVideo.addEventListener('timeupdate', function () {
        if (!modalVideo.duration) return;
        var progress = (modalVideo.currentTime / modalVideo.duration) * 100;
        if (modalScrubberBar) modalScrubberBar.style.width = progress + '%';

        // Update active top segment bar
        if (modalBarsContainer) {
          var fills = modalBarsContainer.querySelectorAll('.mdvp-story-bar-fill');
          if (fills[currentStoryIndex]) {
            fills[currentStoryIndex].style.width = progress + '%';
          }
        }

        // Format timer mm:ss
        if (modalTimer) {
          var cur = Math.floor(modalVideo.currentTime);
          var m = Math.floor(cur / 60);
          var s = cur % 60;
          modalTimer.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        }
      });

      // Video play & pause event listeners
      modalVideo.addEventListener('play', function () {
        if (modalStage) modalStage.classList.remove('is-paused');
      });

      modalVideo.addEventListener('pause', function () {
        if (modalStage) modalStage.classList.add('is-paused');
      });

      // Auto-advance on video end
      modalVideo.addEventListener('ended', function () {
        if (currentStoryIndex < stories.length - 1) {
          goToStory(currentStoryIndex + 1);
        } else {
          closeStoryModal();
        }
      });
    }

    // Scrubber click to seek
    var scrubber = modalEl.querySelector('.mdvp-story-scrubber');
    if (scrubber) {
      scrubber.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!modalVideo || !modalVideo.duration) return;
        var rect = scrubber.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        var pct = Math.max(0, Math.min(1, clickX / rect.width));
        modalVideo.currentTime = pct * modalVideo.duration;
      });
    }

    // Navigation buttons
    var prevBtn = modalEl.querySelector('.mdvp-story-prev');
    var nextBtn = modalEl.querySelector('.mdvp-story-next');
    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goToStory(currentStoryIndex > 0 ? currentStoryIndex - 1 : stories.length - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        goToStory(currentStoryIndex < stories.length - 1 ? currentStoryIndex + 1 : 0);
      });
    }

    // Close buttons
    var closeBtn = modalEl.querySelector('.mdvp-story-close-btn');
    var backdrop = modalEl.querySelector('.mdvp-story-backdrop');
    if (closeBtn) closeBtn.addEventListener('click', closeStoryModal);
    if (backdrop) backdrop.addEventListener('click', closeStoryModal);

    // Keyboard controls
    document.addEventListener('keydown', function (e) {
      if (!isStoryModalOpen) return;
      if (e.key === 'Escape') {
        closeStoryModal();
      } else if (e.key === ' ' || e.code === 'Space') {
        e.preventDefault();
        toggleStoryPlay();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToStory(currentStoryIndex < stories.length - 1 ? currentStoryIndex + 1 : 0);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToStory(currentStoryIndex > 0 ? currentStoryIndex - 1 : stories.length - 1);
      }
    });

    // Touch swipe left/right for mobile story navigation
    var touchStartX = 0;
    var touchStartY = 0;
    if (modalStage) {
      modalStage.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      modalStage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        // Require horizontal swipe greater than vertical movement
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) {
            // Swiped left -> next
            goToStory(currentStoryIndex < stories.length - 1 ? currentStoryIndex + 1 : 0);
          } else {
            // Swiped right -> prev
            goToStory(currentStoryIndex > 0 ? currentStoryIndex - 1 : stories.length - 1);
          }
        }
      }, { passive: true });
    }
  }

  function goToStory(index) {
    if (!stories[index] || !modalVideo) return;
    currentStoryIndex = index;
    var story = stories[index];

    // Reset scrubber and timer
    if (modalScrubberBar) modalScrubberBar.style.width = '0%';
    if (modalTimer) modalTimer.textContent = '0:00';

    // Update top bar segments
    if (modalBarsContainer) {
      var fills = modalBarsContainer.querySelectorAll('.mdvp-story-bar-fill');
      fills.forEach(function (fill, i) {
        if (i < index) {
          fill.style.width = '100%';
        } else {
          fill.style.width = '0%';
        }
      });
    }

    // Update text
    if (modalTitle) modalTitle.textContent = story.title || 'THE RITUAL';
    if (modalCaption) modalCaption.textContent = story.caption || '@MAISONDVUE';

    // Load video
    modalVideo.pause();
    modalVideo.src = story.videoUrl;
    modalVideo.currentTime = 0;

    if (modalStage) modalStage.classList.remove('is-paused');

    // Play with sound enabled (fallback to muted if browser autoplay policy blocks unmuted)
    modalVideo.muted = false;
    if (modalSoundBtn) modalSoundBtn.classList.remove('is-muted');

    modalVideo.play().catch(function () {
      // If unmuted autoplay fails, play muted with sound toggle available
      modalVideo.muted = true;
      if (modalSoundBtn) modalSoundBtn.classList.add('is-muted');
      modalVideo.play().catch(function () {
        if (modalStage) modalStage.classList.add('is-paused');
      });
    });
  }

  function openStoryModal(index) {
    collectStories();
    initStoryModal();
    if (!modalEl) return;

    isStoryModalOpen = true;
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    goToStory(index);
  }

  function closeStoryModal() {
    if (!modalEl) return;
    isStoryModalOpen = false;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (modalVideo) {
      modalVideo.pause();
      modalVideo.src = '';
    }

    clearTimeout(resumeTimeout);
    resumeTimeout = setTimeout(function () {
      isStoryModalOpen = false;
    }, 1200);
  }

  function wire(card) {
    if (card.dataset.mdvpWired) return;
    card.dataset.mdvpWired = '1';

    card.addEventListener('click', function (e) {
      e.preventDefault();
      var cardIndex = parseInt(card.getAttribute('data-index'), 10);
      if (isNaN(cardIndex)) {
        // Fallback: calculate index among original cards
        var all = Array.from(document.querySelectorAll('.mdvp-reel-ribbon .mdvp-reel-card:not([data-mdvp-clone])'));
        cardIndex = all.indexOf(card);
      }
      openStoryModal(cardIndex >= 0 ? cardIndex : 0);
    });
  }

  function setupAutoDrift(ribbon) {
    if (!ribbon || ribbon.dataset.mdvpDriftInit) return;
    ribbon.dataset.mdvpDriftInit = '1';

    // Clone cards once for a seamless, continuous infinite loop
    var originalCards = Array.from(ribbon.querySelectorAll('.mdvp-reel-card:not([data-mdvp-clone])'));
    if (originalCards.length < 3) return;

    var totalCount = originalCards.length;
    var counterEl = ribbon.parentElement ? ribbon.parentElement.querySelector('.mdvp-reel-footer span:first-child') : null;

    originalCards.forEach(function (c) {
      var clone = c.cloneNode(true);
      clone.setAttribute('data-mdvp-clone', '1');
      delete clone.dataset.mdvpWired;
      ribbon.appendChild(clone);
      wire(clone);
    });

    var isInteracting = false;
    var resumeTimeout = null;

    function pauseDrift() {
      isInteracting = true;
      if (resumeTimeout) clearTimeout(resumeTimeout);
    }

    function resumeDrift(delay) {
      if (resumeTimeout) clearTimeout(resumeTimeout);
      resumeTimeout = setTimeout(function () {
        isInteracting = false;
      }, delay || 600);
    }

    // Only bind mouseenter/mouseleave on true desktop pointer devices with hover capability
    var hasHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (hasHover) {
      ribbon.addEventListener('mouseenter', pauseDrift);
      ribbon.addEventListener('mouseleave', function () { resumeDrift(100); });
    }

    // Touch & pointer interaction handling for mobile and desktop drag
    ribbon.addEventListener('touchstart', pauseDrift, { passive: true });
    ribbon.addEventListener('touchmove', pauseDrift, { passive: true });
    ribbon.addEventListener('touchend', function () { resumeDrift(1200); }, { passive: true });
    ribbon.addEventListener('touchcancel', function () { resumeDrift(1200); }, { passive: true });

    ribbon.addEventListener('pointerdown', pauseDrift, { passive: true });
    window.addEventListener('pointerup', function () { resumeDrift(1000); }, { passive: true });
    window.addEventListener('pointercancel', function () { resumeDrift(1000); }, { passive: true });

    var speed = 0.55; // Unhurried luxury drift ~33px per second
    var lastTime = performance.now();

    function updateCounter() {
      if (!counterEl || totalCount === 0) return;
      var firstCard = ribbon.querySelector('.mdvp-reel-card');
      if (!firstCard) return;
      var cardW = firstCard.offsetWidth + (window.innerWidth <= 800 ? 12 : 16);
      var idx = (Math.floor(ribbon.scrollLeft / cardW) % totalCount) + 1;
      var str = (idx < 10 ? '0' : '') + idx;
      if (counterEl.textContent !== str) {
        counterEl.textContent = str;
      }
    }

    function tick(now) {
      var delta = now - lastTime;
      lastTime = now;
      if (delta > 100) delta = 16.667;

      if (!isInteracting && !isStoryModalOpen) {
        var move = speed * (delta / 16.667);
        if (move > 0 && move < 5) {
          ribbon.scrollLeft += move;
        } else {
          ribbon.scrollLeft += speed;
        }

        var half = ribbon.scrollWidth / 2;
        if (half > 0) {
          if (ribbon.scrollLeft >= half) {
            ribbon.scrollLeft -= half;
          } else if (ribbon.scrollLeft <= 0) {
            ribbon.scrollLeft += half;
          }
        }
        updateCounter();
      }

      requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  function init() {
    collectStories();
    initStoryModal();

    var ribbon = document.querySelector('.mdvp-reel-ribbon');
    if (ribbon) {
      document.querySelectorAll('.mdvp-reel-card').forEach(wire);
      setupAutoDrift(ribbon);
    }

    var ritual = document.querySelector('.mdvp-ritual-image');
    if (ritual && !ritual.dataset.mdvpWired) {
      var rv = ritual.querySelector('video');
      var rb = ritual.querySelector('.mdvp-play');
      if (rv && rb) {
        ritual.dataset.mdvpWired = '1';
        rb.addEventListener('click', function () {
          if (rv.paused) { rv.play(); rb.style.opacity = '0'; }
          else { rv.pause(); rv.style.opacity = ''; }
        });
        rv.addEventListener('pause', function () { rb.style.opacity = ''; });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
